import React from 'react';

import { withStyles, Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import { Container, IconButton } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';

import Parse from 'parse';
import moment from 'moment'

import { Button } from '@material-ui/core';
import BackIcon from '@material-ui/icons/ArrowBackIos';
import NewOrder from './newOrder'

const columns = [
    { id: 'code', label: 'Código', maxWidth: 70 },
    { id: 'date', label: 'Fecha', maxWidth: 70 },
    {
        id: 'hour',
        label: 'Hora',
        maxWidth: 50,
    },
    {
        id: 'items',
        label: 'Items',
        maxWidth: 50,
        align: 'right',
    },
    {
        id: 'status',
        label: 'Estado',
        minWidth: 170,
        align: 'right',
    }
]
const columnsDetail = [
    { id: 'code', label: 'Código', maxWidth: 70 },
    { id: 'name', label: 'Producto' },
    {
        id: 'quantity',
        label: 'Cantidad',
        align: "right",
        maxWidth: 50,
    }

]
const useStyles = makeStyles({
    root: {
        minWidth: 275,
        width: "100%"
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    container: {
        maxHeight: 440,
    }

});

const styles = theme => ({
    header: {
        backgroundColor: theme.palette.nav.app,
        [theme.breakpoints.up('sm')]: {
            paddingRight: 104,
            paddingLeft: 104
        },
        [theme.breakpoints.down('sm')]: {
            paddingRight: 48,
            paddingLeft: 48
        },
    },
    headerText: {
        color: '#000',
        fontSize: 28,
        marginTop: 10,
        marginBottom: 10
    },
    buttonColor: {
        backgroundColor: theme.palette.nav.actions,
        color: theme.palette.nav.text
    }
});

class Orders extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            rows: [],
            actualView: 1,
            selectedOrder: null
        }
    }

    componentDidMount() {
        this.getOrders()
    }
    createData = (code, date, hour, items, status, data, id) => {
        return { code, date, hour, items, status, data, id };
    }
    getOrders = async (x) => {
        if (!x) {
            x = {
                start: new Date(1395300399099).setHours(0, 0, 0, 0), end: new Date().setHours(23, 59, 59, 99)
            }
        }
        if (localStorage.historialPedidos.length > 0) {
            this.setState({ rows: JSON.parse(localStorage.historialPedidos) })

        }
        else {
            const query = new Parse.Query('Orders')
            query.equalTo('envId', localStorage.env)
            query.equalTo('or', 2)
            query.descending('t')
            query.greaterThan('cfost', localStorage.client + "true" + 0 + localStorage.sellerCode + x.start)
                .lessThan('cfost', localStorage.client + "true" + 3 + localStorage.sellerCode + x.end)
            const result = await query.find()
            const rowres = []
            for (var i in result) {
                const elem = result[i]
                const elemAttr = elem.attributes
                var a = moment(elemAttr.te);
                var b = moment();
                const std = b.diff(a, 'days') // 1 (b-a) = dias
                var st = "Pendiente"
                if (elemAttr.s > 1) {
                    if (std < 8) {
                        st = "En proceso"
                    }
                    else {
                        st = "Finalizado"
                    }
                }
                rowres.push(this.createData(elemAttr.sk, moment(elemAttr.te).format('DD/MM/YYYY'), moment(elemAttr.te).format('hh:mm:ss'), Object.keys(elemAttr.o).length, st, elemAttr, elem.id))
            }
            this.setState({ rows: rowres })
            localStorage.historialPedidos = JSON.stringify(rowres)
        }
    }



    render() {
        const { classes } = this.props;

        return (
            <div>
                <div className={classes.header}>
                    {
                        this.state.actualView === 1 ?
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", height: 115 }}>
                                <div style={{ zIndex: 1 }}>
                                    <p className={classes.headerText}>Pedidos</p>
                                    <p style={{ fontSize: 13 }}><b> Vendedor : </b> {localStorage.sellerName} ({localStorage.sellerCode})</p>
                                </div>
                                <Button
                                    onClick={() => { this.setState({ actualView: 3 }) }}
                                    className={classes.buttonColor}
                                    style={{ height: 40, paddingLeft: 20, paddingRight: 20, fontWeight: 'bold' }}
                                    variant="contained" size="small"
                                >
                                    Nuevo pedido
                                </Button>
                            </div>
                            :
                            this.state.actualView === 2 ?
                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", height: 115 }}>
                                    <div style={{ zIndex: 1, flexDirection: "row" }}>

                                        <div className={classes.headerText}>
                                            <IconButton onClick={() => { this.setState({ actualView: 1, selectedOrder: null }) }} aria-label="delete" size="small">
                                                <BackIcon style={{ fontSize: 24 }} />
                                            </IconButton>Pedido {this.state.selectedOrder ? this.state.selectedOrder.sk : null}
                                        </div>
                                    </div>
                                    {
                                        this.state.selectedOrder ?
                                            <div style={{ textAlign: "right" }}>
                                                <p style={{ fontSize: 13 }}>{moment(this.state.selectedOrder.te).format('DD/MM/YYYY [a las] HH:mm')}</p>
                                                <p style={{ fontSize: 13 }}>{(this.state.selectedOrder.st === 1 ? ('Pendiente') : this.state.selectedOrder.st === 2 ? ('En proceso') : ('Finalizado'))}</p>
                                            </div>
                                            :
                                            null
                                    }
                                </div>
                                :
                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", height: 115 }}>
                                    <div style={{ zIndex: 1 }}>

                                        <p className={classes.headerText}>
                                            <IconButton onClick={() => { this.setState({ actualView: 1 }) }} aria-label="delete" size="small">
                                                <BackIcon style={{ fontSize: 24 }} />
                                            </IconButton> Nuevo Pedido</p>

                                    </div>
                                    <div>
                                        <p style={{ fontSize: 13 }}><b> Vendedor : </b> {localStorage.sellerName} ({localStorage.sellerCode})</p>
                                    </div>
                                </div>
                    }


                </div>
                <Container maxWidth="lg" style={{ marginTop: 50 }}>
                    {this.state.actualView === 1 || this.state.actualView === 2 ?
                        <OrdersTable view={this.state.actualView} changeView2={(x, y) => { this.props.changeView(x, y) }} changeView={(x, y, z) => { this.setState({ actualView: 2, selectedOrder: { sk: x, te: y, st: z } }) }} rows={this.state.rows}></OrdersTable>
                        :
                        <NewOrder changeView2={(x, y) => { this.props.changeView(x, y) }} changeView3={(x, y, z) => { this.props.changeView(x, y) }} changeView={(x, y, z) => { this.setState({ actualView: 2, selectedOrder: { sk: x, te: y, st: z } }) }}></NewOrder>
                    }
                </Container>

            </div>
        )
    }
}
const StyledTableCell = withStyles((theme: Theme) =>
    createStyles({
        head: {
            // backgroundColor: theme.palette.common.black,
            // color: theme.palette.common.white,
        },
        body: {
            fontSize: 14,
        },
    }),
)(TableCell);

const StyledTableRow = withStyles((theme: Theme) =>
    createStyles({
        root: {
            '&:nth-of-type(odd)': {
                backgroundColor: theme.palette.action.hover,
            },
        },
    }),
)(TableRow);

function OrdersTable(props) {
    const classes = useStyles();
    // const bull = <span className={classes.bullet}>•</span>;
    const [page, setPage] = React.useState(0);
    const [selectedOrder, setOrder] = React.useState(null);

    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const { rows } = props;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const seeOrder = (x) => {
        setOrder(x)
        props.changeView(x.sk, x.te, x.s)

    }


    // getOrders()
    if (props.view === 2) {
        return (
            <Paper className={classes.root}>
                <TableContainer >
                    <Table stickyHeader size="small" aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columnsDetail.map((column) => (
                                    <TableCell
                                        key={column.id}

                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Object.values(selectedOrder.o).map((rowData, key) => {
                                const row = { code: rowData.pld.k, name: rowData.n, quantity: rowData.q }
                                return (
                                    <StyledTableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                        {columnsDetail.map((column) => {
                                            const value = row[column.id];


                                            return (
                                                <StyledTableCell key={column.id} align={column.align}>
                                                    {column.format && typeof value === 'number' ? column.format(value) : value}
                                                </StyledTableCell>
                                            );
                                        })}
                                    </StyledTableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        )
    } else {

        return (

            <Paper className={classes.root}>
                <TableContainer className={classes.container}>
                    <Table stickyHeader size="small" aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, key) => {
                                return (
                                    <StyledTableRow onClick={() => { seeOrder(row.data) }} role="checkbox" tabIndex={-1} key={row.code}>
                                        {columns.map((column) => {
                                            const value = row[column.id];

                                            if (value === "Finalizado") {
                                                return (
                                                    <StyledTableCell key={column.id} style={{ fontWeight: "bold", color: "#74CF40" }} align={column.align}>
                                                        {column.format && typeof value === 'number' ? column.format(value) : value}
                                                    </StyledTableCell>
                                                );
                                            }
                                            return (
                                                <StyledTableCell key={column.id} align={column.align}>
                                                    {column.format && typeof value === 'number' ? column.format(value) : value}
                                                </StyledTableCell>
                                            );
                                        })}
                                    </StyledTableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    labelRowsPerPage="Filas por página"
                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                />
            </Paper>
        );
    }
}

export default withStyles(styles)(Orders);
